import { FC } from 'react'
import { TipoReceitaSncr, IconPaths } from '_metronic/helpers'
import { LinhaSaldoSncr } from '../../hooks/useSaldoSncr'
import styles from '../../Prescricao.module.scss'
import { Icone } from '../comum/Icone'
import { useRotulos } from '../comum/useRotulos'
import { isNotificacaoSncr } from '../../../../sncr/core/_models'
import { Button, InfoAlert } from 'app/components'
import { idRetirarBloco } from './ids'

type IProps = {
  linhas: LinhaSaldoSncr[]
  onRetirar: (tipo: TipoReceitaSncr) => void
}

/**
 * Numeração SNCR: quanto os documentos consomem e quanto há, com a retirada ali mesmo — bloco
 * para RCE/RET, números avulsos para notificação, nos termos da tela do SNCR. Sem "x de N blocos
 * no mês": só contamos o retirado por aqui, e o médico pode ter retirado em outra plataforma.
 */
export const SecaoSncr: FC<IProps> = ({ linhas, onRetirar }) => {
  const { t } = useRotulos()
  if (linhas.length === 0) return null

  return (
    <section aria-labelledby='revisao-sncr' className={styles.secao}>
      <h3 id='revisao-sncr' className='fs-6 fw-bold mb-3'>
        {t('prescricao.sncr.titulo')}
      </h3>
      <InfoAlert variant='warning' size='sm' role='note' className='mb-3'>
        {t('prescricao.sncr.reserva')}
      </InfoAlert>
      <table className='table table-row-bordered align-middle mb-2'>
        <thead>
          <tr className={`fs-8 fw-bold ${styles.textoSecundario}`}>
            <th scope='col'>{t('prescricao.sncr.tipo')}</th>
            <th scope='col'>{t('prescricao.sncr.necessario')}</th>
            <th scope='col'>{t('prescricao.sncr.disponivel')}</th>
            <th scope='col'>{t('prescricao.sncr.situacao')}</th>
            <th scope='col' className='text-end'>
              <span className='visually-hidden'>{t('prescricao.resultado.acoes')}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((linha) => {
            const notificacao = isNotificacaoSncr(linha.tipo)
            const classe =
              linha.falta > 0
                ? styles.pendenciaErro
                : linha.baixo
                ? styles.pendenciaAviso
                : styles.estadoOk
            return (
              <tr key={linha.tipo}>
                <th scope='row'>{linha.tipo}</th>
                <td>{linha.necessario}</td>
                <td>{linha.disponivel}</td>
                <td>
                  <span className={`fw-bold ${styles.comIcone} ${classe}`}>
                    <Icone
                      icone={linha.falta > 0 || linha.baixo ? IconPaths.Alert : IconPaths.Check}
                    />
                    {linha.falta > 0
                      ? t('prescricao.sncr.faltam', { quantidade: linha.falta })
                      : linha.baixo
                      ? t('prescricao.sncr.baixo')
                      : t('prescricao.sncr.suficiente')}
                  </span>
                </td>
                <td className='text-end'>
                  {(linha.falta > 0 || linha.baixo) && (
                    <Button
                      id={idRetirarBloco(linha.tipo)}
                      size='btn-sm'
                      className='btn-primary text-nowrap'
                      onClick={() => onRetirar(linha.tipo)}
                      ariaLabel={t(
                        notificacao ? 'sncr.alerta.retirar_aria_nr' : 'sncr.alerta.retirar_aria',
                        { sigla: linha.tipo }
                      )}
                    >
                      {t(notificacao ? 'sncr.alerta.retirar_nr' : 'sncr.alerta.retirar')}
                    </Button>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </section>
  )
}
